export default __webpack_public_path__ + "static/media/iaq.7c65d34a.png";